import * as React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Button, InputGroup, FormGroup } from "@blueprintjs/core";
import { Spacer } from "components/common";
import { useControlledInput } from "hooks/";
import { useAuthActions } from "context/";
import Error from "./Error";
import { withPreventDefault } from "utils";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuthActions();
  const {
    valid: $email,
    reset: resetEmail,
    ...email
  } = useControlledInput((v) => v !== "");
  const {
    valid: $password,
    reset: resetPassword,
    ...password
  } = useControlledInput((v) => v !== "");
  const [error, setError] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirect = params.get("redirect");

  return (
    <form
      onSubmit={withPreventDefault((event) => {
        if ($email && $password) {
          setLoading(true);
          login(email.value, password.value).then((result) => {
            if (result !== true) {
              setLoading(false);
              setError(result);
            } else {
              navigate(redirect || "/folders");
            }
          });
        }
      })}
    >
      <FormGroup label="Login Email" labelFor="email-input">
        <InputGroup
          id="email-input"
          placeholder="Login Email"
          autoComplete="email"
          {...email}
        />
      </FormGroup>
      <FormGroup label="Password" labelFor="password-input">
        <InputGroup
          id="password-input"
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          autoComplete="current-password"
          {...password}
          rightElement={
            <Button
              variant="minimal"
              icon={showPassword ? "eye-off" : "eye-open"}
              onClick={() => setShowPassword((v) => !v)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            />
          }
        />
      </FormGroup>
      <Error message={error} />
      <Button type="submit" intent="primary" large fill loading={loading}>
        Login
      </Button>
      <Spacer />
      <Link to="/resetpassword">Forgot Password?</Link>
    </form>
  );
};

export default Login;
